import { type DollarPriceInputProps } from '@wix/da-shared-react/pkg/DollarPriceInput';

export type CommonProps = Pick<DollarPriceInputProps, 'min' | 'inputMode' | 'forceInteger'>;

export const commonDollarPriceInputProps: CommonProps = {
  min: 1,
  inputMode: 'numeric',
  forceInteger: true,
};
